import '../front.css';
import React from 'react';
import logo from '../img/logo2.png'
import waiter from '../img/wait.svg'
import FieldYesNo from './fields/fieldYesNo';

export default class EmailSubscription extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            devis: false
        }
    }


    componentDidMount() {
        this.props.api.registerDevisView(this)
        if ( this.props.id ) {
            this.props.api.post(
                {action:'get_devis',
                 id:this.props.id},
                ()=>{}
            )
        }
    }

    componentWillUnmount() {
        this.props.api.unregisterDevisView(this)
    }

    changeParams(params) {
        console.log(params)
        this.props.api.post(
            {
                action:'change_params',
                id:this.props.id,
                params:JSON.stringify(params),
                devis_timestamp:Date.now()
            },
            ()=>{}
        )
    }


    receiveDevis(devis) {
        if ( this.props.id == devis._id.$oid ) {
            this.setState({devis:devis})
        }
    }

    render() {

        const container = {
            devis:this.state.devis,
            changeParams:this.changeParams.bind(this),
            showValidate:false,
            focusError: ()=>{},
            setPage: ()=>{}
        }

        return <div className="front"><div className="header">
                <div className="logobox">
                    <a href="https://www.assurbonplan.fr/" target="_blank"><img src={logo}/></a>
                </div>
                <div className="headbox">
                </div>
            </div>
            <div className="body">
                
                { ( ! this.state.devis )
                    ?<div className="bigoverlay"><img src={waiter} className="big_waiter"/></div>
                    :<>
                        <div className="titlebox widetitlebox" ref={this.props.topRef}>
                            Abonnements emails
                        </div>
                        <div className="container">
                            <div className="contentbox_margin"/>
                            <div className="contentbox front_form">
                                <p>Vous pouvez désactiver les envois automatiques d'emails, à l'exception des emails répondant à une demande de souscription de votre part (envoi de vos documents d'assurance, etc...), ou en réponse à une nouvelle demande de devis de votre part.</p>
                                <FieldYesNo field="automatic_emails" container={container} />
                            </div>
                            <div className="contentbox_margin"/>
                        </div>
                    </>}
            </div>
        </div>
    }
}
